import PropTypes from "prop-types";
import SeccionWrapper from "../SeccionWrapper";
import StepInfoAdicional from "../../FormularioPropuestaV2/steps/StepInfoAdicional";

const SeccionInfoAdicional = ({ formik, faltantes }) => (
  <SeccionWrapper
    id="seccion-info-adicional"
    numero={7}
    titulo="Información adicional"
    faltantes={faltantes}
  >
    <StepInfoAdicional formik={formik} />
  </SeccionWrapper>
);

SeccionInfoAdicional.propTypes = {
  formik: PropTypes.object.isRequired,
  faltantes: PropTypes.arrayOf(PropTypes.string),
};

export default SeccionInfoAdicional;
